import UsersList from "../../components/Users/UsersList";

const usersRoutes = [
    { path: '', name: 'UsersList', component: UsersList,
    },
];

export default usersRoutes;
